var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.65779 0.825497C10.0934 1.26817 10.0934 2.00302 9.66633 2.45455L4.48222 7.84634H18.6483C19.2546 7.84634 19.75 8.35984 19.75 8.99729C19.75 9.63475 19.2546 10.1483 18.6483 10.1483H4.48222L9.67487 15.54C10.1019 15.9916 10.0934 16.7176 9.66633 17.1691C9.23076 17.6118 8.53898 17.6118 8.10341 17.1602L1.066 9.81182C0.972055 9.70558 0.895189 9.59048 0.835405 9.44882C0.775622 9.30717 0.75 9.15666 0.75 9.00615C0.75 8.70513 0.861027 8.42182 1.066 8.20048L8.10341 0.852058C8.5219 0.391675 9.22222 0.382821 9.65779 0.825497Z",
    fill: "#704DE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.289f37568df93b0bfa05756aeac2412d.svg";
export { ForwardRef as ReactComponent };